import dayjs from "dayjs";
import "../styles/index.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import CheckboxAvanBen from "./CheckboxAvanBen";
import Exigence from "./Exigence";
import { API_URL } from "constants/ApiUrl";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAnnouncement,
  resetDeleteStatus,
  resetUpdateStatus,
  updateAnnouncement,
} from "store/slices/agentAnnonceSlice";

const {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  ModalBody,
  ModalHeader,
  Modal,
  Form,
  ModalFooter,
} = require("reactstrap");

const ALL_AVANTAGES = [
  { key: "accommodation", label: "Accommodation" },
  { key: "transport", label: "Transport" },
  { key: "equipment", label: "Equipment" },
  { key: "salary", label: "Salary" },
  { key: "contract", label: "Contract" },
];

const AnnonceItem = ({ annonce }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    updateLoading,
    updateError,
    updateSuccess,
    deleteLoading,
    deleteError,
    deleteSuccess,
  } = useSelector((state) => state.AgentAnnonce);

  const role = localStorage.getItem("role");
  const baseEndpoint =
    role === "club"
      ? `${API_URL}/api/club/announcements`
      : `${API_URL}/api/agent/announcements`;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: annonce.title || "",
    description: annonce.description || "",
    endDate: dayjs(annonce.endDate).format("YYYY-MM-DD"),
    position: annonce.position || "",
    category: annonce.category || [],
    region: annonce.region || "",
    location: annonce.location || "",
    requirements: Array.isArray(annonce.requirements)
      ? annonce.requirements
      : (annonce.requirements || "").split(",").map((s) => s.trim()),
    benefits: Array.isArray(annonce.benefits) ? annonce.benefits : [],
    status: annonce.status || "active",
  });

  const avantageList = ALL_AVANTAGES.map((opt) => ({
    key: opt.key,
    label: opt.label,
    checked: formData.benefits.includes(opt.key),
  }));

  useEffect(() => {
    if (updateSuccess) {
      toast.success("Annonce mise à jour avec succès", {
        toastId: "update-annonce-success",
      });
      setModalOpen(false);

      setTimeout(() => {
        window.location.reload();
      }, 1000);

      dispatch(resetUpdateStatus());
    }
  }, [updateSuccess, dispatch]);

  useEffect(() => {
    if (updateError) {
      toast.error(updateError);
      dispatch(resetUpdateStatus());
    }
  }, [updateError, dispatch]);

  useEffect(() => {
    if (deleteSuccess) {
      toast.success("Annonce supprimée avec succès", {
        toastId: "delete-annonce-success",
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);

      dispatch(resetDeleteStatus());
    }
  }, [deleteSuccess, dispatch]);

  useEffect(() => {
    if (deleteError) {
      toast.error(deleteError);
      dispatch(resetDeleteStatus());
    }
  }, [deleteError, dispatch]);

  const toggle = () => setModalOpen(!modalOpen);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  const handleCategoryChange = (e) => {
    const { options } = e.target;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) selected.push(options[i].value);
    }
    setFormData((f) => ({ ...f, category: selected }));
  };

  const handleRequirements = (list) => {
    setFormData((f) => ({ ...f, requirements: list }));
  };

  const handleBenefits = (newListOrFn) => {
    const actualList =
      typeof newListOrFn === "function"
        ? newListOrFn(avantageList)
        : newListOrFn;

    const selectedKeys = actualList
      .filter((av) => av.checked)
      .map((av) => av.key);

    setFormData((f) => ({
      ...f,
      benefits: selectedKeys,
    }));
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        ...formData,
        requirements: formData.requirements.join(", "),
      };

      if (role === "agent") {
        dispatch(
          updateAnnouncement({
            id: annonce._id,
            payload: payload,
          })
        );
      } else {
        const res = await fetch(`${baseEndpoint}/${annonce._id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authUser")}`,
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.message || "Mise à jour échouée");
        }

        const updated = await res.json();
        toast.success("Annonce mise à jour avec succès");
        toggle();

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer cette annonce ?"
    );

    if (!isConfirmed) return;

    if (isConfirmed) {
      try {
        if (role === "agent") {
          dispatch(deleteAnnouncement(id));
        } else {
          const res = await fetch(`${baseEndpoint}/${id}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authUser")}`,
            },
          });

          if (!res.ok) {
            const errData = await res.json();
            throw new Error(errData.message || "Delete failed");
          }

          toast.success("Annonce supprimée avec succès");

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.error("error:", error);
        toast.error(error.message || "Une erreur s'est produite");
      }
    }
  };

  const voirAnnonceDetails = (id) => {
    navigate("/annonces/details", { state: { id: id } });
  }
  const styles = {
    titre: {
      font: "Poppins",
      color: "#000000",
      fontSize: 15,
      fontWeight: 500,
    },
    info: {
      color: "#000000",
      fontWeight: 300,
    },
  };
  return (
    <Row key={annonce.id} className="mb-3">
      {/* Premier Row */}
      <Row className="d-flex justify-content-center">
        <Col md="7">
          {/* Deux Rows à l'intérieur */}
          <Row>
            {/* Première ligne avec titre, statut, date et vues */}
            <Col lg="8">
              <div style={{ marginBottom: 5 }}>
                <span style={styles.titre}>{t("announceItem.title")}: </span>
                <span style={styles.info}> {annonce.title}</span>
              </div>
              <div style={{ marginBottom: 13 }}>
                <span style={styles.titre}>{t("announceItem.status")}: </span>
                <span style={styles.info}>{annonce.status}</span>
              </div>
            </Col>
            <Col lg="4" className="col-align-lg-end">
              <div>
                <div style={{ marginBottom: 5 }}>
                  <span style={styles.titre}>
                    {t("announceItem.publishedDate")}:
                  </span>
                  <span style={styles.info}>
                    <span style={styles.info}>
                      {" "}
                      {dayjs(annonce.datePublication).format("DD/MM/YYYY")}
                    </span>
                  </span>
                </div>
                {annonce.nombreVue !== null && (
                  <div style={{ marginBottom: 13 }}>
                    <span style={styles.titre}>
                      {t("announceItem.Views")}:{" "}
                    </span>
                    <span style={styles.info}> {annonce.nombreVue}</span>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <div className="d-flex justify-content-between">
              <Button
                style={{
                  backgroundColor: "#ffffff",
                  color: "#157088",
                  border: "solid 1px #157088",
                  borderRadius: 5,
                  width: 90,
                }}
                onClick={() => {
                  console.log(annonce._id);
                  voirAnnonceDetails(annonce._id);
                }}
              >
                {t("announceItem.details")}
              </Button>
              <Button
                style={{
                  backgroundColor: "#157088",
                  color: "#ffffff",
                  border: "solid 1px #157088",
                  borderRadius: 5,
                  width: 90,
                }}
                onClick={toggle}
              >
                {t("announceItem.modify")}
              </Button>
              <Button
                style={{
                  backgroundColor: "#ECD8D9",
                  color: "#E55A5D",
                  // border: "solid 1px",
                  borderRadius: 5,
                  width: 90,
                }}
                onClick={() => handleDelete(annonce._id)}
              >
                {t("announceItem.delete")}
              </Button>
            </div>
          </Row>
        </Col>
      </Row>

      <Modal isOpen={modalOpen} toggle={toggle} style={{ width: "100%" }}>
        <ModalHeader toggle={toggle}>{t("editAd.modalHeader")}</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="title">{t("editAd.title")}</Label>
                  <Input
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>

              <Col>
                <FormGroup>
                  <Label for="description">{t("editAd.description")}</Label>
                  <Input
                    type="textarea"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label for="position">{t("editAd.position")}</Label>
                  <Input
                    type="select"
                    id="position"
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                  >
                    <option value="Goalkeeper">{t("editAd.goalkeeper")}</option>
                    <option value="Defender">{t("editAd.defender")}</option>
                    <option value="Midfielder">{t("editAd.midfielder")}</option>
                    <option value="Forward">{t("editAd.forward")}</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col>
                <FormGroup>
                  <Label for="category">{t("editAd.ageCategory")}</Label>
                  <select
                    className="form-select"
                    type="select"
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleCategoryChange}
                  >
                    <option value="u14-u15">U14–U15 (14–15 ans)</option>
                    <option value="u16-u17">U16–U17 (16–17 ans)</option>
                    <option value="u18-u19">U18–U19 (18–19 ans)</option>
                    <option value="u20-u21">U20–U21 (20–21 ans)</option>
                    <option value="seniors">Seniors (18+ ans)</option>
                  </select>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label for="endDate">{t("editAd.endDate")}</Label>
                  <Input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="region">{t("editAd.region")}</Label>
                  <Input
                    id="region"
                    name="region"
                    value={formData.region}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label for="location">{t("editAd.location")}</Label>
                  <Input
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="status">{t("editAd.status")}</Label>
                  <Input
                    type="select"
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="active">{t("editAd.active")}</option>
                    <option value="inactive">{t("editAd.inactive")}</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Exigence
                exigences={formData.requirements}
                setExigences={handleRequirements}
              />
            </FormGroup>

            <FormGroup>
              <Label>{t("editAd.benefits")}</Label>
              <CheckboxAvanBen
                avantages={avantageList}
                setAvantages={handleBenefits}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t("editAd.cancel")}
          </Button>
          <Button color="primary" onClick={handleUpdate}>
            {t("editAd.save")}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Deuxième Row avec ligne de séparation */}
      <Row className="d-flex justify-content-center">
        <Col md="9">
          <hr />
        </Col>
      </Row>
    </Row>
  );
};

export default AnnonceItem;
